<div>
  <div class="table-label"> Open Records </div>
  <div class="table-container open-records-table">
    <table>
      <thead>
        <tr>
          @for (status of approvalStatuses; track status.label) {
            <th (click)="navWithFilters(status.label)">
              {{ status.label }}
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (scoreClass of scoreClasses; track scoreClass.color) {
          <tr>
            @for (status of approvalStatuses; track status.label) {
              <td (click)="navWithFilters(status.label, scoreClass.varName)">
                <div class="pending-trade-info">
                  <span class="icon-container me-1">
                    <mat-icon [class]="scoreClass.varName">
                      {{ scoreClass.icon }}
                    </mat-icon>
                  </span>
                  @if (gridSummaryRes && gridSummaryRes[status.varName]) {
                    {{ gridSummaryRes[status.varName][scoreClass.varName] }}
                  }
                </div>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>

    <ngx-loading
      [show]="ptSvc.loading()"
      [config]="{ fullScreenBackdrop: false }"
    />
  </div>
</div>
